import request from '@/utils/request'

export function getObj(params) {
  return request({
    url: '/api/financeInfo/qrySystemSetting',
    method: 'get',
    params
  })
}

export function putObj(data) {
  return request({
    url: '/api/financeInfo/updateSystemSetting',
    method: 'post',
    data
  })
}
